export default "__VITE_ASSET__BVc8F_5O__"